export default "__VITE_ASSET__0AyS$fnI__"